export enum PdfMergeType {
  credit = 0,
  deliveryForm = 1,
  fittingForm = 2,
  invoice = 3,
  proForma = 4,
  quote = 5,
  workForm = 6,
}
